const SELECTORS = {
	PRODUCT_CARD: '.buy-box--product',
	PRODUCT_SUBSCRIPTION_PRICE: '.price-subscription',
	PRODUCT_ONE_TIME_PRICE: '.price-one-time',
	PRODUCT_PRICE_VARIANT: '.price__regular',
	PRODUCT_PRICE_COMPARE: '.price__compare_price',
	PRODUCT_PRICE_SAVINGS: '.price__savings',
	PRODUCT_DETAIL_LIST: '.selling-plan-options .content__one-time ul'
}

const init = () => {
	const productCardEls = document.querySelectorAll(SELECTORS.PRODUCT_CARD)

	productCardEls.forEach((el, i) => {

		if (i === 0) {
			el.style.display = 'flex'
			const target = el.querySelector(`${SELECTORS.PRODUCT_DETAIL_LIST} li:first-child strong`)
			target.textContent = '$10'
			return
		}

		const prices = {
			oneTime: [
				el.querySelector(`${SELECTORS.PRODUCT_ONE_TIME_PRICE} ${SELECTORS.PRODUCT_PRICE_VARIANT}`),
				el.querySelector(`${SELECTORS.PRODUCT_ONE_TIME_PRICE} ${SELECTORS.PRODUCT_PRICE_COMPARE} s`),
				el.querySelector(`${SELECTORS.PRODUCT_ONE_TIME_PRICE} ${SELECTORS.PRODUCT_PRICE_SAVINGS}`)
			],
			subscription: [
				el.querySelector(`${SELECTORS.PRODUCT_SUBSCRIPTION_PRICE} ${SELECTORS.PRODUCT_PRICE_VARIANT}`),
				el.querySelector(`${SELECTORS.PRODUCT_SUBSCRIPTION_PRICE} ${SELECTORS.PRODUCT_PRICE_COMPARE} s`),
				el.querySelector(`${SELECTORS.PRODUCT_SUBSCRIPTION_PRICE} ${SELECTORS.PRODUCT_PRICE_SAVINGS}`)
			]
		}

		if (i === 1) {
			prices.oneTime[1].textContent = '$109'
			prices.subscription[1].textContent = '$109'
			prices.oneTime[2].textContent = 'Save $50'
			prices.subscription[2].textContent = 'Save $60'
		}
		else if (i === 2) {
			prices.oneTime[1].textContent = '$170'
			prices.subscription[1].textContent = '$170'
			prices.oneTime[2].textContent = 'Save $71'
			prices.subscription[2].textContent = 'Save $71'
		}
	})
}

init()